import React from 'react';
import DateToFromPicker from "../../../touristServices/components/dateToFromPicker";
import SearchSelect from "../../../../components/searchSelect";
import {Form} from "react-bootstrap";
import _ from "lodash";
import ApiSelect from "../../../base/components/forms/apiSelect";

const ListQueryForm = ({query, setQuery}) => {
  return (
    <div className={'d-flex gap-2'}>
      <div style={{position: 'relative', width: '9rem'}}>
        <label className={'absolutLabel'}>Имя</label>
        <Form.Control
          name={'pax'}
          value={query.pax}
          defaultValue={''}
          onChange={(e) => setQuery(q => ({...q, pax: e.target.value}))}
          className={'form-control'}
          type={'text'}
        />
      </div>
      <div style={{position: 'relative', width: '7rem'}}>
        <label className={'absolutLabel'}>Бронирование</label>
        <Form.Control
          name={'bookingNumber'}
          defaultValue={''}
          value={query.bookingNumber}
          onChange={(e) => setQuery(q => ({...q, bookingNumber: e.target.value}))}
          className={'form-control'}
          type={'text'}
        />
      </div>
      <div style={{position: 'relative', width: '10rem'}}>
        <label className={'absolutLabel'}>№ Билета</label>
        <Form.Control
          name={'ticketNumber'}
          defaultValue={""}
          value={query.ticketNumber}
          onChange={(e) => setQuery(q => ({...q, ticketNumber: e.target.value}))}
          className={'form-control'}
          type={'text'}
        />
      </div>
      <div style={{width: '12rem'}}>
        <ApiSelect
          value={query.buyer || ''}
          label={'Покупатель'}
          url={"/api/counterparty/searchInput"}
          cb={newVal => {
            setQuery(q => ({...q, buyer: newVal}));
          }}
        />
      </div>
      <div style={{width: '15rem'}}>
        <DateToFromPicker label={'Дата выписки с - по'}
                          defaultValue={query.issueDate ? {
                            start: query.issueDate[0],
                            end: query.issueDate[1]
                          } : {}}
                          setOptions={(v) => {
                            setQuery(q => ({...q, issueDate: v}))
                          }}/>
      </div>

      <div style={{width: '6.5rem'}}>
        <SearchSelect
          onChange={(v) => {
            setQuery(q => ({...q, issuedWithoutDocs: v}))
          }}
          defaultValue={query.issuedWithoutDocs || ""}
          label={"Документы"}
          array={[{value: '', label: 'Все'}, {value: false, label: 'С док.'}, {
            value: true,
            label: 'Без'
          }]}/>
      </div>
      <div style={{width: '6.5rem'}}>
        <SearchSelect
          onChange={(v) => {
            setQuery(q => ({...q, paid: v}))
          }}
          defaultValue={query.paid}
          label={"Оплачено"}
          unregister
          array={[{value: '', label: 'Все'}, {value: false, label: 'Нет'}, {
            value: true,
            label: 'Да'
          }]}/>
      </div>
      <div style={{width: '6.5rem'}}>
        <SearchSelect
          onChange={(v) => {
            setQuery(q => ({...q, zakup: v}))
          }}
          defaultValue={query.zakup}
          label={"Закуп"}
          unregister
          array={[{value: '', label: 'Все'}, {value: false, label: 'Нет'}, {
            value: true,
            label: 'Да'
          }]}/>
      </div>

    </div>
  );
};

export default ListQueryForm;
